import ProposalTrades from './components/proposal-trades'

const IndexDTFAuctionsLegacy = () => {
  return (
    <div>
      <ProposalTrades />
    </div>
  )
}

export default IndexDTFAuctionsLegacy
